import React, { useState, useEffect, useMemo } from 'react';
import ClaySticker from '@clayui/sticker';
import './ProfileCard.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

export const getProfieNameImg = (name: string): string => {
    const words = name?.split(' ');
    const firstLetter = words[0][0]?.toUpperCase();
    const lastLetter = words[words?.length - 1][0];

    return firstLetter + lastLetter;
};

const ProfileCard = () => {
    const userData = useSelector(
        (state: RootState) => state.userDetailsSlice.userDetails
    );

    const requestorData = useSelector(
        (state: RootState) => state.requestorsSlice.requestorDetails
    );

    const userDetails = useMemo(() => {
        const details = {
            UAEStageGen: '',
            membershipId: '',
            mobileNumber: ''
        };

        requestorData?.forEach((item: any) => {
            if (item?.membershipNumber && item?.membershipNumber !== 'null') {
                details.membershipId = item.membershipNumber;
            }

            if (
                item?.requestorMobileNumber &&
                item?.requestorMobileNumber !== 'null'
            ) {
                details.mobileNumber = item.requestorMobileNumber;
            }

            if (
                item?.businessOwnedOrCofoundedByUAE?.name &&
                item?.businessOwnedOrCofoundedByUAE?.name !== 'null'
            ) {
                details.UAEStageGen = item.businessOwnedOrCofoundedByUAE.name;
            }
        });

        return details;
    }, [requestorData]);

    return (
        <>
            <div className="profile_card">
                <div className="img-placeholder">
                    {userData?.image ? (
                        <img
                            width={100}
                            height={100}
                            style={{ borderRadius: '50%' }}
                            src={
                                // (window as any)?.Liferay?.ThemeDisplay?.getPortalURL() +
                                userData?.image ??
                                '/o/esg-custom-element/images/userProfile.png'
                            }
                        />
                    ) : (
                        <ClaySticker
                            displayType="unstyled"
                            size="lg"
                            className="esg-profile-sticker"
                        >
                            <span className="profile-img">
                                {userData?.name &&
                                    getProfieNameImg(userData?.name!)}
                            </span>
                        </ClaySticker>
                    )}
                </div>

                <div className="profile_details">
                    <div>
                        <h5 className="home_titles mb-0">{userData?.name}</h5>
                    </div>
                    <div className="profile_contact mt-1">
                        <div className="contact-detail mr-3">
                            <span>Membership ID : </span>
                            {userDetails?.membershipId || 'N/A'}
                        </div>
                        <div className="contact-detail">
                            <span>UAE Resident : </span>
                            {userDetails?.UAEStageGen || 'No'}
                        </div>
                    </div>
                    <div className="info-icon">
                        <div className="d-flex align-items-center">
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.7752 21.6666C19.3707 21.6666 17.9307 21.3149 16.4552 20.6116C14.9796 19.9077 13.6091 18.9202 12.3435 17.6491C11.0768 16.3774 10.0918 15.0066 9.3885 13.5366C8.68516 12.0666 8.3335 10.6294 8.3335 9.22492C8.3335 8.97047 8.41683 8.75853 8.5835 8.58909C8.75016 8.41853 8.9585 8.33325 9.2085 8.33325H11.2693C11.496 8.33325 11.6938 8.40464 11.8627 8.54742C12.0316 8.6902 12.1457 8.87297 12.2052 9.09575L12.6185 11.0833C12.6574 11.3166 12.6504 11.5202 12.5977 11.6941C12.5454 11.868 12.4532 12.0105 12.321 12.1216L10.4918 13.8266C10.8341 14.4477 11.2121 15.0244 11.626 15.5566C12.0399 16.0894 12.4816 16.5941 12.951 17.0708C13.4343 17.5541 13.9549 18.0041 14.5127 18.4208C15.0704 18.8369 15.6827 19.2296 16.3493 19.5991L18.1318 17.7849C18.2674 17.6388 18.4199 17.5424 18.5893 17.4958C18.7588 17.4496 18.946 17.4405 19.151 17.4683L20.9043 17.8266C21.1304 17.8821 21.3141 17.996 21.4552 18.1683C21.5963 18.341 21.6668 18.5391 21.6668 18.7624V20.7916C21.6668 21.0416 21.5818 21.2499 21.4118 21.4166C21.2424 21.5833 21.0296 21.6666 20.7752 21.6666ZM10.1002 13.0449L11.7002 11.5733C11.7535 11.531 11.7879 11.4724 11.8035 11.3974C11.8202 11.3224 11.8174 11.253 11.7952 11.1891L11.426 9.42242C11.4043 9.33742 11.3668 9.27353 11.3135 9.23075C11.2602 9.18797 11.191 9.16659 11.106 9.16659H9.396C9.33211 9.16659 9.27877 9.18797 9.236 9.23075C9.19322 9.27353 9.17183 9.32686 9.17183 9.39075C9.18794 9.9602 9.27683 10.5546 9.4385 11.1741C9.60127 11.7941 9.82127 12.4177 10.1002 13.0449ZM17.1427 19.9899C17.706 20.2688 18.306 20.4752 18.9427 20.6091C19.5804 20.7424 20.136 20.8138 20.6093 20.8233C20.6732 20.8233 20.7266 20.8021 20.7693 20.7599C20.8121 20.7171 20.8335 20.6635 20.8335 20.5991V18.9266C20.8335 18.841 20.8121 18.7716 20.7693 18.7183C20.7266 18.6644 20.6627 18.6269 20.5777 18.6058L19.036 18.2899C18.9716 18.2688 18.9152 18.266 18.8668 18.2816C18.8191 18.2983 18.7685 18.333 18.7152 18.3858L17.1427 19.9899Z"
                                    fill="#003764"
                                />
                            </svg>
                            <div className="contact-detail mt-0 ml-2">
                                <span>
                                    {' '}
                                    {userDetails?.mobileNumber || '-'}{' '}
                                </span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.84583 20.8334C8.4625 20.8334 8.1425 20.7051 7.88583 20.4484C7.62861 20.1912 7.5 19.8709 7.5 19.4876V10.5126C7.5 10.1292 7.62861 9.80925 7.88583 9.55258C8.1425 9.29536 8.4625 9.16675 8.84583 9.16675H21.1542C21.5375 9.16675 21.8575 9.29536 22.1142 9.55258C22.3714 9.80925 22.5 10.1292 22.5 10.5126V19.4876C22.5 19.8709 22.3717 20.1909 22.115 20.4476C21.8578 20.7048 21.5375 20.8334 21.1542 20.8334H8.84583ZM15 15.0959L8.33333 10.7376V19.4876C8.33333 19.637 8.38139 19.7598 8.4775 19.8559C8.57361 19.952 8.69639 20.0001 8.84583 20.0001H21.1542C21.3036 20.0001 21.4264 19.952 21.5225 19.8559C21.6186 19.7598 21.6667 19.637 21.6667 19.4876V10.7376L15 15.0959ZM15 14.1667L21.41 10.0001H8.59L15 14.1667ZM8.33333 10.7376V10.0001V19.4876C8.33333 19.637 8.38139 19.7598 8.4775 19.8559C8.57361 19.952 8.69639 20.0001 8.84583 20.0001H8.33333V10.7376Z"
                                    fill="#003764"
                                />
                            </svg>
                            <div className="contact-detail mt-0 ml-2">
                                <span>{userData?.emailAddress ?? '-'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProfileCard;
